export const GENERIC_CANCEL_FAILURE_MESSAGE =
  'We could not cancel this session. Please try again.';

export const CALENDAR_NOT_OWNED_CANCEL_MESSAGE =
  "This coach's calendar is not managed by Mento Calendar. Nothing was cancelled.";

// Moments `admin_policy_rejected` reasons (422). Each names the rule that
// refused the request.
const ADMIN_POLICY_MESSAGES: Record<string, string> = {
  book_unsafe:
    'Mento Calendar refused this change as unsafe. Nothing was cancelled.',
  cancel_reason_missing:
    'A cancellation reason is required. Nothing was cancelled.',
  initiator_invalid:
    'Choose whether the coach or the member asked to cancel. Nothing was cancelled.',
  ops_note_missing:
    'A note for Mento operations is required. Nothing was cancelled.',
  scope_not_allowed:
    'That cancellation scope is not allowed for this session. Nothing was cancelled.',
};

interface CancelFailure {
  data?: { error?: unknown; reason?: unknown } | null;
}

/**
 * Plain-English copy for a failed cancel submit. Classifies only coded
 * refusals (`coach_not_native_calendar` from Moments or Rails, and Moments
 * `admin_policy_rejected` reasons); anything else gets the generic retry copy.
 */
export const cancelFailureMessage = (cause: unknown): string => {
  if (!cause || typeof cause !== 'object') {
    return GENERIC_CANCEL_FAILURE_MESSAGE;
  }
  const { data } = cause as CancelFailure;
  const code = typeof data?.error === 'string' ? data.error : undefined;
  if (code === 'coach_not_native_calendar') {
    return CALENDAR_NOT_OWNED_CANCEL_MESSAGE;
  }
  if (code === 'admin_policy_rejected' && typeof data?.reason === 'string') {
    const message = ADMIN_POLICY_MESSAGES[data.reason];
    if (message) return message;
  }
  return GENERIC_CANCEL_FAILURE_MESSAGE;
};
